export enum LessonPaymentStatus {
  AWAITS,
  PAID,
  CLOSED,
}
